import { render } from "./Consultant.vue?vue&type=template&id=755b7c09"
import script from "./Consultant.vue?vue&type=script&lang=js"
export * from "./Consultant.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__